<template>
<div>
  <van-field
    :placeholder="placeholder"
    :label="label"
    v-model="showStr"
    :rules="rules"
    is-link
    readonly
    :required="required"
    :disabled="disabled"
    @click="handleClick"
  />
<van-action-sheet v-model="show" title="请选择省/市/区">
  <div class="content">
    <van-area 
      :title="''" 
      :area-list="areaList" 
      value="110101" 
      @confirm="confirm" 
      @cancel="cancel" 
      @change="change"
    />
  </div>
</van-action-sheet>    
</div>  
</template>

<script>
import { areaList } from '@vant/area-data'
export default {
  props: {
    label: {
      type: String,
      default: '地址'
    },
    value: [String, Array],
    name: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
  },
  model: {
    event: 'input',
  },
  data() {
    return {
      showStr: '',
      show: false,
      areaList,
      current: [],
    }
  },
  watch: {
    name(val) {
      this.showStr = val
    }
  },
  created() {
    // this.getCustomers()
    this.showStr = this.name
  },  
  methods: {
    handleClick() {
      if(this.disabled) return
      this.show = true
    },
    confirm() {
      this.show = false
      const strArr = this.current.map(it => {
        return it.name
      })
      this.showStr = strArr
      this.$emit('input', strArr)
      this.$emit('selected', strArr)
    },
    cancel() {
      this.show = false
    },
    change(picker, value, index) {
      this.current = value
    },
  },
}
</script>